import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { layoutSizes, colours } from "../../constants/css";
import styled from 'styled-components';
var CheckBoxContainer = styled.div.withConfig({
  displayName: "Toggle__CheckBoxContainer",
  componentId: "sc-mtbf1x-0"
})(["display:inline-block;vertical-align:middle;position:relative;width:35px;height:25px;@media only screen and (min-width:", "){width:50px;height:30px;}"], layoutSizes.desktopWidth);
var CheckBox = styled.input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "Toggle__CheckBox",
  componentId: "sc-mtbf1x-1"
})(["position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;opacity:0;cursor:pointer;&:checked + label{background:", ";&:after{left:calc(100% + 1px);transform:translateX(-100%);}}"], colours.qantasAqua);
var CheckBoxLabel = styled.label.withConfig({
  displayName: "Toggle__CheckBoxLabel",
  componentId: "sc-mtbf1x-2"
})(["cursor:pointer;text-indent:-9999px;width:100%;height:100%;background:", ";display:block;border-radius:100px;position:relative;border:solid 2px ", ";&:after{content:'';position:absolute;top:0px;left:-1px;width:54%;height:91%;background:", ";border-radius:100%;transition:0.3s;border:solid 1px ", ";}&:active:after{width:100%;}"], colours.qantasGrey, colours.qantasGray91, colours.qantasWhite, colours.qantasGray91);
var Toggle = /*#__PURE__*/function (_Component) {
  function Toggle(props) {
    var _this;
    _classCallCheck(this, Toggle);
    _this = _callSuper(this, Toggle, [props]);
    _this.handleCheckboxChange = function (e) {
      var checked = e.target.checked;
      _this.setState({
        checked: checked
      });
      _this.props.onChange(checked);
    };
    _this.state = {
      checked: _this.props.checked
    };
    return _this;
  }
  _inherits(Toggle, _Component);
  return _createClass(Toggle, [{
    key: "render",
    value: function render() {
      return __jsx(CheckBoxContainer, null, __jsx(CheckBox, {
        checked: this.state.checked,
        onChange: this.handleCheckboxChange
      }), __jsx(CheckBoxLabel, null));
    }
  }]);
}(Component);
Toggle.defaultProps = {
  checked: false,
  onChange: function onChange() {}
};
export default Toggle;